import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-full flex px-5 space-x-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "从组织架构选择", -1)
const _hoisted_3 = { class: "text-subtle text-sm" }
const _hoisted_4 = { class: "w-1/2 h-full flex flex-col" }
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "h-10 leading-10 font-medium" }, "添加成员", -1)
const _hoisted_7 = { class: "flex-grow" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont text-3xl text-gray-5 float-right" }, "", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 添加 ")

import { computed, ref } from 'vue'
import { Notify, useDialogPluginComponent } from 'quasar'
import { useUserProfile } from '@/composables/user/useUserProfile'
import { useChatGroupStore } from '@/store/user-chat-group'
import { useProfileStore } from '@/store/user-profile'

import DialogContentLayout from '@/layouts/DialogContentLayout.vue'
import AddMemberFromNormalVue from './AddMemberFromNormal.vue'
import AddMemberFromOaVue from './AddMemberFromOa.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    hostId: null,
    groupId: null
  },
  emits: [...useDialogPluginComponent.emits],
  setup(__props: any) {

const props = __props as {
    hostId: string
    groupId: string
}




const { dialogRef, onDialogHide, onDialogCancel, onDialogOK } = useDialogPluginComponent()

const profileStore = useProfileStore()
const groupStore = useChatGroupStore()

const isSelectingFromOA = ref(false)
const adding = ref(false)
const selected = ref<Set<string>>(new Set())
const oaIframe = ref<typeof AddMemberFromOaVue | null>(null)

const selectedProfiles = computed(() => {
    return Array.from(selected.value).map((i) => {
        const { userProfile, displayAvatar, displayName } = useUserProfile(i)
        return {
            id: i,
            avatar: displayAvatar.value,
            profile: userProfile.value,
            displayName: displayName.value,
        }
    })
})

async function addMembers() {
    adding.value = true
    try {
        await groupStore.addMembers(props.hostId, props.groupId, Array.from(selected.value))
        onDialogOK()
    } catch (error) {
        console.log(error)
        Notify.create({ message: error instanceof Error ? error.message : (error as string) })
    } finally {
        adding.value = false
    }
}

function deleteMember(id: string) {
    selected.value.delete(id)
    oaIframe.value?.syncSelectedUser()
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_base_btn = _resolveComponent("base-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(DialogContentLayout, {
        style: {"height":"600px","width":"640px","max-width":"640px"},
        "no-head": "",
        class: "q-dialog-plugin"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_scroll_area, { class: "w-1/2" }, {
              default: _withCtx(() => [
                (_unref(profileStore).myProfile?.staffInfo)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isSelectingFromOA.value ? (isSelectingFromOA.value = false) : (isSelectingFromOA.value = true))),
                      class: _normalizeClass(["mr-4 mb-1 p-3 rounded-md grid items-center cursor-pointer", isSelectingFromOA.value ? 'bg-gray-4' : 'bg-gray-1']),
                      style: {"grid-template-columns":"30px 1fr 18px","gap":"10px"}
                    }, [
                      _createVNode(_component_q_img, {
                        src: require('theme/icons/default-avatar-oa.svg'),
                        "no-spinner": ""
                      }, null, 8, ["src"]),
                      _createElementVNode("div", null, [
                        _hoisted_2,
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(profileStore).myProfile.staffInfo.entName), 1)
                      ]),
                      _createVNode(_component_q_icon, {
                        name: isSelectingFromOA.value ? 'cancel' : 'more_vert',
                        color: "subtle",
                        size: "18px"
                      }, null, 8, ["name"])
                    ], 2))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(AddMemberFromNormalVue, {
                  modelValue: selected.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event))
                }, null, 8, ["modelValue"]), [
                  [_vShow, !isSelectingFromOA.value]
                ]),
                _withDirectives(_createVNode(AddMemberFromOaVue, {
                  ref_key: "oaIframe",
                  ref: oaIframe,
                  modelValue: selected.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selected).value = $event))
                }, null, 8, ["modelValue"]), [
                  [_vShow, isSelectingFromOA.value]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedProfiles), (profile) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: profile.id,
                    class: "h-13 flex items-center space-x-2.5"
                  }, [
                    _createVNode(_component_q_avatar, {
                      rounded: "",
                      size: "30px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_img, {
                          src: profile.avatar,
                          "no-spinner": "",
                          "no-transition": ""
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(profile.displayName), 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (deleteMember(profile.id))
                    }, _hoisted_10, 8, _hoisted_8)
                  ]))
                }), 128))
              ]),
              _createVNode(_component_q_card_actions, {
                align: "right",
                class: "p-0 mb-4 pt-5 space-x-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_btn, {
                    onClick: _unref(onDialogCancel),
                    outline: "",
                    padding: "8px 25px"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_base_btn, {
                    onClick: addMembers,
                    disable: Array.from(selected.value).length === 0,
                    loading: adding.value,
                    padding: "8px 25px"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["disable", "loading"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})